import * as vp from 'vopay';
import { FunctionComponent, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogueHandler, CancelTransactionDialogueHandler } from '../types';
import VoidTransactionDialogueContext from './VoidTransactionContext';

const { ConfirmationDialogue } = vp;

type VoidTransactionDialogueProps = {
  handleDialogue: DialogueHandler<CancelTransactionDialogueHandler>;
};

type FC = FunctionComponent<VoidTransactionDialogueProps>;

const VoidTransactionDialogue: FC = ({ handleDialogue }: VoidTransactionDialogueProps) => {
  const { showVoidTransactionConfirmAlert, showVoidTransactionErrorAlert, sendVoidTransactionError } =
    useContext(VoidTransactionDialogueContext);
  const { t } = useTranslation('translations', {
    keyPrefix: 'Transaction.Dialogue.VoidTransaction.VoidTransactionDialogue',
  });
  return useMemo(
    () => (
      <div>
        {/* Transaction Void Confirmation */}
        <ConfirmationDialogue
          isVisible={showVoidTransactionConfirmAlert}
          title={t('confirmDialogue.title')}
          status="alert"
          subTitle=""
          confirm={{
            label: t('confirmDialogue.yes'),
            action: () => handleDialogue({ type: 'alert', state: 'success' }),
          }}
          cancel={{
            label: t('confirmDialogue.no'),
            action: () => handleDialogue({ type: 'alert', state: 'fail' }),
          }}
        />
        {/* Transaction Void Error */}
        <ConfirmationDialogue
          isVisible={showVoidTransactionErrorAlert}
          title={t('errorDialogue.title')}
          status="error"
          subTitle={`${sendVoidTransactionError}`}
          confirm={{
            label: t('errorDialogue.back'),
            action: () => handleDialogue({ type: 'error', state: 'fail' }),
          }}
        />
      </div>
    ),
    [showVoidTransactionConfirmAlert, showVoidTransactionErrorAlert, sendVoidTransactionError],
  );
};

export default VoidTransactionDialogue;
